export default IconRewindBackward50 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-rewind-backward-50" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M19.007 16.466a6 6 0 0 0 -4.007 -10.466h-11" />
  <path d="M12 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z" />
  <path d="M6 20h1.5a1.5 1.5 0 0 0 0 -3h-1.5v-3h3" />
  <path d="M7 9l-3 -3l3 -3" />
</svg>`;